<template>
  <div class="product-detail-page">
    <Nav/>
    <!-- 产品基本信息区域 -->
    <div class="product-basic-info">
      <!-- 产品图片预览区 -->
      <div class="product-images">
        <div class="image-preview-area">
          <div
              class="main-image-container"
              @mousemove="handleMouseMove"
              @mouseenter="showZoom = true"
              @mouseleave="resetZoom"
          >
            <el-image
                :src="currentImage"
                :alt="product.name"
                fit="fill"
                class="main-image"
                ref="mainImage"
            />
            <div
                v-if="showZoom"
                class="image-zoom-lens"
                :style="lensStyle"
            ></div>
          </div>
        </div>

        <!-- 缩略图列表 -->
        <div class="thumbnail-list">
          <div
              v-for="(img, index) in product.detailImages"
              :key="index"
              :class="['thumbnail', { active: currentImageIndex === index }]"
              @click="switchImage(index)"
          >
            <img :src="img" :alt="`${product.name} 图片 ${index + 1}`" />
          </div>
        </div>
      </div>

      <!-- 产品信息区域 -->
      <div class="product-info">
        <div class="product-info-wrapper">
          <h1 class="product-title">{{ product.name }}</h1>
          <div class="product-price">
            <span class="current-price">¥{{ product.price }}</span>
          </div>

          <!-- 产品规格选择 -->
          <div class="spec-section" v-for="spec in product.specs" :key="spec.name">
            <h3 class="spec-title">{{ spec.name }}：</h3>
            <div class="spec-options">
            <span
                v-for="(option, i) in spec.values"
                :key="i"
                :class="[
                'spec-option',
                {
                  selected: selectedSpecs[spec.name] === option,
                  disabled: false
                }
              ]"
                @click="selectSpec(spec.name, option)"
            >
              {{ option }}
            </span>
            </div>
          </div>

          <div class="product-sales">
              <span v-if="maxQuantity">库存: {{ maxQuantity }}件</span>
              <span v-else class="sold-out">库存: (无货)</span>
          </div>

          <!-- 操作按钮 -->
          <div class="action-buttons">
<!--            <button class="btn btn-cart" @click="addToCart">-->
<!--              <i class="fas fa-shopping-cart"></i> 加入购物车-->
<!--            </button>-->
            <button v-if="this.product.buyUrl" class="btn btn-buy" @click="buyNow">
              <i class="fas fa-bolt"></i> 立即购买
            </button>
<!--            <button class="btn btn-favorite" @click="toggleFavorite">-->
<!--              <i :class="['far', isFavorite ? 'fa-heart' : 'fa-heart']"></i>-->
<!--              {{ isFavorite ? '已收藏' : '收藏' }}-->
<!--            </button>-->
          </div>
        </div>
        <!-- 右侧放大预览区域 -->
        <div
            v-if="showZoom"
            class="zoom-preview"
            :style="zoomPreviewStyle"
        >
          <div
              class="zoom-preview-image"
              :style="zoomImageStyle"
          ></div>
        </div>
      </div>
    </div>

    <!-- 产品详情图文展示 -->
    <div class="product-detail-content">
      <div class="detail-tabs">
        <div
            v-for="tab in tabs"
            :key="tab.id"
            :class="['tab-item', { active: activeTab === tab.id }]"
            @click="activeTab = tab.id"
        >
          {{ tab.name }}
        </div>
      </div>

      <div class="tab-content">
        <!-- 产品详情 -->
        <div v-show="activeTab === 'detail'" class="product-description">
          <div v-html="product.description"></div>
        </div>

<!--        &lt;!&ndash; 产品参数 &ndash;&gt;-->
<!--        <div v-show="activeTab === 'specs'" class="product-specifications">-->
<!--          <table class="spec-table">-->
<!--            <tr v-for="(value, key) in product.parameters" :key="key">-->
<!--              <td class="param-name">{{ key }}</td>-->
<!--              <td class="param-value">{{ value }}</td>-->
<!--            </tr>-->
<!--          </table>-->
<!--        </div>-->

<!--        &lt;!&ndash; 用户评价 &ndash;&gt;-->
<!--        <div v-show="activeTab === 'reviews'" class="product-reviews">-->
<!--          <div v-for="review in product.reviews" :key="review.id" class="review-item">-->
<!--            <div class="review-header">-->
<!--              <span class="review-user">{{ review.user }}</span>-->
<!--              <div class="review-rating">-->
<!--                <i-->
<!--                    v-for="star in 5"-->
<!--                    :key="star"-->
<!--                    :class="['fas fa-star', star <= review.rating ? 'active' : '']"-->
<!--                ></i>-->
<!--              </div>-->
<!--              <span class="review-date">{{ review.date }}</span>-->
<!--            </div>-->
<!--            <p class="review-content">{{ review.content }}</p>-->
<!--          </div>-->
<!--        </div>-->
      </div>
    </div>
    <Footer class="top"/>
  </div>
</template>

<script>
import {getProductById} from "@/api";
import Nav from "@/views/front/components/Nav.vue";
import {Footer} from "element-ui";

export default {
  name: 'ProductDetail',
  data() {
    return {
      // 当前显示图片索引
      currentImageIndex: 0,
      // 放大镜显示状态
      showZoom: false,
      // 放大镜位置和大小
      lensStyle: {
        left: '0px',
        top: '0px',
        width: '50px',
        height: '50px'
      },
      // 右侧放大预览区域样式
      zoomPreviewStyle: {
        display: 'none'
      },
      // 右侧放大预览图片样式
      zoomImageStyle: {
        backgroundImage: '',
        backgroundPosition: '0px 0px',
        backgroundSize: '200% 200%'
      },
      // 选择的规格
      selectedSpecs: {},
      // 购买数量
      quantity: 1,
      // 是否收藏
      isFavorite: false,
      // 当前激活的标签页
      activeTab: 'detail',
      // 标签页数据
      tabs: [
        { id: 'detail', name: '产品详情' },
        // { id: 'specs', name: '规格参数' },
        // { id: 'reviews', name: '用户评价' }
      ],
      // 产品数据
      product: {}
      // product: {
      //   // parameters: {
      //   //   '材质': '100%棉',
      //   //   '克重': '180g',
      //   //   '版型': '标准版',
      //   //   '领型': '圆领',
      //   //   '袖长': '短袖',
      //   //   '适用季节': '夏季',
      //   //   '产地': '中国'
      //   // },
      //   // reviews: [
      //   //   { id: 1, user: '张三', rating: 5, date: '2023-07-15', content: '衣服质量很好，穿着舒适，下次还会购买！' },
      //   //   { id: 2, user: '李四', rating: 4, date: '2023-07-10', content: '颜色很正，尺码标准，值得推荐。' },
      //   //   { id: 3, user: '王五', rating: 5, date: '2023-07-05', content: '纯棉材质确实舒服，夏天穿很凉快。' }
      //   // ]
      // }
    }
  },
  components: {
    Nav,
    Footer
  },
  computed: {
    // 当前显示的图片
    currentImage() {
      if( this.product && this.product.detailImages) {
        return this.product.detailImages[this.currentImageIndex]
      }
    },
    // 最大购买数量（根据库存和规格库存）
    maxQuantity() {
      let max = 0
      // 简化逻辑：如果有选择规格，取规格库存，否则取产品总库存
      if(!this.product.skuList) return max;
      // 检查所有已选规格的库存
      for (let i in this.product.skuList) {
        let specs = this.product.skuList[i].specs;
        if (!specs) {
          continue;
        }
        let count = 0;
        for(let key in specs) {
          if(specs[key] === this.selectedSpecs[key]){
            break;
          }
          count++;
        }
        if(count === Object.keys(specs).length) {
          max = this.product.skuList[i].stock;
          break;
        }
      }
      return max
    }
  },
  methods: {
    // 切换图片
    switchImage(index) {
      this.currentImageIndex = index
      this.resetZoom()
      // 更新放大预览的背景图片
      this.zoomImageStyle.backgroundImage = `url(${this.currentImage})`
    },
    // 处理鼠标移动（放大镜效果）
    handleMouseMove(event) {
      if (!this.showZoom) return

      if(window.innerWidth <= 768){
        this.showZoom = false;
        return;
      }

      const container = event.currentTarget
      // const img = this.$refs.mainImage
      const containerRect = container.getBoundingClientRect()

      // 计算鼠标在图片上的相对位置
      let x = event.clientX - containerRect.left
      let y = event.clientY - containerRect.top

      // 限制放大镜在图片范围内
      const lensWidth = 50
      const lensHeight = 50

      // 计算放大镜位置（确保不会超出图片边界）
      const maxX = containerRect.width - lensWidth
      const maxY = containerRect.height - lensHeight

      x = Math.max(0, Math.min(x - lensWidth / 2, maxX))
      y = Math.max(0, Math.min(y - lensHeight / 2, maxY))

      // 设置放大镜位置
      this.lensStyle = {
        left: `${x}px`,
        top: `${y}px`,
        width: `${lensWidth}px`,
        height: `${lensHeight}px`
      }

      // 计算放大预览区域的背景位置
      // 放大倍数为2倍，所以背景图片需要移动的位置是放大镜位置的2倍
      const bgPosX = -x * 2
      const bgPosY = -y * 2

      // 更新放大预览区域的背景位置
      this.zoomImageStyle.backgroundPosition = `${bgPosX}px ${bgPosY}px`

      // 显示右侧放大预览区域
      this.zoomPreviewStyle.display = 'block'
    },
    // 重置放大效果
    resetZoom() {
      this.showZoom = false
      this.zoomPreviewStyle.display = 'none'
    },
    // 选择规格
    selectSpec(specName, specValue) {
      // // 如果已选中，取消选择；否则选中
      if (this.selectedSpecs[specName] === specValue) {
        this.$delete(this.selectedSpecs, specName)
      } else {
        this.$set(this.selectedSpecs, specName, specValue)
      }
    },
    // // 加入购物车
    // addToCart() {
    //   // 验证规格是否选择完整
    //   if (this.product.specs.length > 0 && Object.keys(this.selectedSpecs).length < this.product.specs.length) {
    //     alert('请先选择完整的产品规格')
    //     return
    //   }
    //
    //   const cartItem = {
    //     productId: this.product.id,
    //     name: this.product.name,
    //     price: this.product.price,
    //     image: this.currentImage,
    //     specs: { ...this.selectedSpecs },
    //     quantity: this.quantity
    //   }
    //
    //   alert(`已加入购物车：${this.product.name} x ${this.quantity}`)
    //   console.log('加入购物车:', cartItem)
    // },
    // 立即购买
    buyNow() {
      window.open(this.product.buyUrl);
    },
    // // 切换收藏状态
    // toggleFavorite() {
    //   this.isFavorite = !this.isFavorite
    //   alert(this.isFavorite ? '已添加到收藏夹' : '已取消收藏')
    // }
    async fetchData(){
      try {
        const productId = this.$route.params.id;
        // console.log('Fetching product with ID:', productId);
        const response = await getProductById(productId);
        // console.log('Product data received:', response);
        if (response.code === 0) {
          this.product = response.data;
          if(this.product) {
            this.product.detailImages.unshift(this.product.mainImage);
            if(this.product.skuList){
              this.product.skuList = JSON.parse(this.product.skuList);
            }
            if(this.product.specs){
              this.product.specs = JSON.parse(this.product.specs);
            }
          }
          this.initImage();
        } else {
          throw new Error(response.message || '获取产品详情失败');
        }
      } catch (error) {
        console.error('获取产品详情失败:', error);
        this.error = '获取产品详情失败，请稍后再试';
        // 可以添加更多的错误处理逻辑，比如显示一个错误提示
      }
    },
    initImage(){
      // 初始化默认选择第一个有库存的规格
      if(this.product.skuList) {
        const availableOption = this.product.skuList.find(option => option.stock > 0)
        if (availableOption) {
          this.selectedSpecs = availableOption.specs;
        }
      }
      // 初始化放大预览的背景图片
      this.zoomImageStyle.backgroundImage = `url(${this.currentImage})`;

      if(!this.product.description){
        this.product.description = '';
      }
      if(this.product.detailImages){
        let html = '';
        for(let i in this.product.detailImages) {
          let image = this.product.detailImages[i];
          html += `<img src="${image}" alt="图${i}" width="100%"/>`;
        }
        this.product.description += html;
      }
    }
  },
  mounted() {
    this.fetchData();
  }
}
</script>

<style lang="scss" scoped>
.product-detail-page {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
  font-family: 'Segoe UI', 'Microsoft YaHei', sans-serif;
}

.product-basic-info {
  display: flex;
  flex-wrap: wrap;
  gap: 40px;
  background: white;
  border-radius: 12px;
  padding: 30px;
  margin-top: 75px;
  margin-bottom: 30px;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.05);
}

.product-images {
  flex: 1;
  min-width: 400px;
}

.image-preview-area {
  display: flex;
  gap: 20px;
  margin-bottom: 20px;
}

.main-image-container {
  position: relative;
  border: 1px solid #eee;
  border-radius: 8px;
  overflow: hidden;
  height: 450px;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fafafa;
  cursor: zoom-in;
}

//.main-image {
//  max-width: 100%;
//  max-height: 100%;
//  display: block;
//}

.image-zoom-lens {
  position: absolute;
  border: 2px solid #ff6b6b;
  background-color: rgba(255, 107, 107, 0.1);
  pointer-events: none;
  left: 0;
  top: 0;
  z-index: 10;
}

.zoom-preview {
  width: 100%;
  height: 100%;
  z-index: 100;
  position: absolute;
  top: 0;
  left: 0;
  border: 1px solid #eee;
  border-radius: 8px;
  overflow: hidden;
  background: #fafafa;
  display: flex;
  align-items: center;
  justify-content: center;
}

.zoom-preview-image {
  width: 100%;
  height: 100%;
  background-repeat: no-repeat;
  background-color: #fafafa;
}

.thumbnail-list {
  display: flex;
  gap: 12px;
  overflow-x: auto;
  padding: 10px 0;
}

.thumbnail {
  width: 80px;
  height: 80px;
  border: 2px solid transparent;
  border-radius: 6px;
  overflow: hidden;
  cursor: pointer;
  flex-shrink: 0;
  transition: all 0.2s;
}

.thumbnail:hover {
  border-color: #ddd;
}

.thumbnail.active {
  border-color: #ff6b6b;
}

.thumbnail img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.product-info {
  flex: 1;
  min-width: 400px;
  position: relative;

  .product-info-wrapper {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
  }
}

.product-title {
  font-size: 24px;
  font-weight: 600;
  margin-bottom: 10px;
  color: #222;
}

.product-subtitle {
  color: #666;
  margin-bottom: 20px;
  font-size: 14px;
}

.product-price {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.current-price {
  font-size: 30px;
  color: #ff6b6b;
  font-weight: 700;
  margin-right: 15px;
}

.original-price {
  font-size: 18px;
  color: #999;
  text-decoration: line-through;
  margin-right: 15px;
}

.discount-tag {
  background: #ff6b6b;
  color: white;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 14px;
}

.product-sales {
  color: #666;
  margin-bottom: 25px;
}

.product-sales span {
  margin-right: 20px;
}

.spec-section {
  margin-bottom: 25px;
}

.spec-title {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 12px;
  color: #333;
}

.spec-options {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.spec-option {
  padding: 8px 18px;
  border: 1px solid #ddd;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s;
  user-select: none;
}

.spec-option:hover {
  border-color: #ff6b6b;
  color: #ff6b6b;
}

.spec-option.selected {
  background-color: #ff6b6b;
  color: white;
  border-color: #ff6b6b;
}

.spec-option.disabled {
  background-color: #f5f5f5;
  color: #ccc;
  cursor: not-allowed;
}

.spec-option.disabled:hover {
  border-color: #ddd;
  color: #ccc;
}

.sold-out {
  font-size: 12px;
  color: #999;
}

.quantity-section {
  display: flex;
  align-items: center;
  margin-bottom: 30px;
}

.quantity-title {
  font-size: 16px;
  font-weight: 600;
  margin-right: 20px;
  color: #333;
}

.quantity-control {
  display: flex;
  align-items: center;
  margin-right: 15px;
}

.quantity-btn {
  width: 36px;
  height: 36px;
  border: 1px solid #ddd;
  background: white;
  font-size: 18px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.quantity-btn:disabled {
  background-color: #f5f5f5;
  color: #ccc;
  cursor: not-allowed;
}

.quantity-input {
  width: 60px;
  height: 36px;
  border: 1px solid #ddd;
  border-left: none;
  border-right: none;
  text-align: center;
  font-size: 16px;
}

.stock-tip {
  color: #666;
  font-size: 14px;
}

.action-buttons {
  display: flex;
  gap: 15px;
  flex-wrap: wrap;
}

.btn {
  padding: 12px 30px;
  border: none;
  border-radius: 6px;
  font-size: 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  transition: all 0.2s;
}

.btn-cart {
  background-color: #ff9f43;
  color: white;
}

.btn-cart:hover {
  background-color: #ff8c1a;
}

.btn-buy {
  background-color: #ff6b6b;
  color: white;
}

.btn-buy:hover {
  background-color: #ff5252;
}

.btn-favorite {
  background-color: white;
  color: #333;
  border: 1px solid #ddd;
}

.btn-favorite:hover {
  background-color: #f5f5f5;
}

.product-detail-content {
  background: white;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.05);
}

.detail-tabs {
  display: flex;
  border-bottom: 1px solid #eee;
  background: #fafafa;
}

.tab-item {
  padding: 15px 30px;
  cursor: pointer;
  font-weight: 500;
  color: #666;
  transition: all 0.2s;
}

.tab-item:hover {
  color: #ff6b6b;
}

.tab-item.active {
  color: #ff6b6b;
  border-bottom: 2px solid #ff6b6b;
  background: white;
}

.tab-content {
  padding: 30px;
}

.product-description {
  line-height: 1.8;
}

.product-description h3 {
  margin: 20px 0 10px;
  color: #333;
}

.product-description p {
  margin-bottom: 15px;
  color: #555;
}

.product-description img {
  max-width: 100%;
  border-radius: 6px;
  margin: 15px 0;
}

.spec-table {
  width: 100%;
  border-collapse: collapse;
}

.spec-table tr {
  border-bottom: 1px solid #eee;
}

.spec-table tr:last-child {
  border-bottom: none;
}

.param-name {
  width: 150px;
  padding: 12px 20px;
  color: #666;
  background-color: #fafafa;
}

.param-value {
  padding: 12px 20px;
  color: #333;
}

.review-item {
  padding: 20px 0;
  border-bottom: 1px solid #eee;
}

.review-item:last-child {
  border-bottom: none;
}

.review-header {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.review-user {
  font-weight: 600;
  margin-right: 15px;
}

.review-rating {
  margin-right: 15px;
  color: #ffc107;
}

.review-rating .fa-star:not(.active) {
  color: #ddd;
}

.review-date {
  color: #999;
  font-size: 14px;
}

.review-content {
  color: #555;
  line-height: 1.6;
}

/* 响应式设计 */
//@media (max-width: 992px) {
//  .product-basic-info {
//    flex-direction: column;
//  }
//
//  .product-images, .product-info {
//    min-width: 100%;
//  }
//
//  .action-buttons {
//    justify-content: center;
//  }
//}

@media (max-width: 768px) {
  .image-preview-area {
    flex-direction: column;
  }

  .thumbnail-list {
    flex-wrap: wrap;
  }

  .zoom-preview {
    width: 100%;
    height: 300px;
  }

  .main-image-container {
    flex: unset;
    height: 350px;
  }

  .product-basic-info {
    //display: unset;
    padding: unset;
  }

  .product-info {
    flex: unset;
    min-width: unset;

    .product-info-wrapper {
      position: unset;
    }
  }

  .product-description {
    overflow-x: hidden;
  }
}

@media (max-width: 576px) {
  .product-detail-page {
    padding: 10px;
  }

  .product-basic-info {
    //display: unset;
    padding: unset;
  }

  .main-image-container {
    flex: unset;
    //height: 300px;
  }

  .thumbnail-list {
    flex-wrap: wrap;
  }

  .product-info {
    flex: unset;
    min-width: unset;

    .product-info-wrapper {
      position: unset;
    }
  }

  .zoom-preview {
    height: 250px;
  }

  .action-buttons {
    flex-direction: column;
  }

  .btn {
    width: 100%;
  }

  .product-description {
    overflow-x: hidden;
  }
}
</style>
